"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  domId: _propTypes["default"].string.isRequired,
  items: _propTypes["default"].array.isRequired,
  container: _propTypes["default"].object.isRequired,
  scrollingElement: _propTypes["default"].any,
  options: _propTypes["default"].object,
  eventsListener: _propTypes["default"]["function"],
  totalItemsCount: _propTypes["default"].number,
  resizeMediaUrl: _propTypes["default"]["function"]
};
exports["default"] = _default;